import { Carousel } from "react-responsive-carousel";
import { MdRemoveRedEye } from "react-icons/md";
import { Role, useGetWalletQuery } from "../generated/graphql";
import { useSelector } from "react-redux";
import { RootState } from "../store";

export default function Balance() {
  const { data: walletData } = useGetWalletQuery({
    fetchPolicy: "cache-and-network",
  });

  const loggedInRole = useSelector(
    (state: RootState) => state.loggedInUser.role
  );

  const styles = {
    height: "4px",
    width: "4px",
    display: "inline-block",
    marginRight: "5px",
    borderRadius: "3px",
    background: "#B3B6BA",
  };

  return (
    <Carousel
      statusFormatter={(current, total) =>
        `Current slide: ${current} / Total: ${total}`
      }
      showArrows={false}
      showThumbs={false}
      showStatus={false}
      renderIndicator={(onClickHandler, isSelected, index, label) => {
        if (isSelected) {
          return (
            <li
              style={{ ...styles, background: "#4285f4" }}
              aria-label={`Selected: ${label} ${index + 1}`}
            />
          );
        }
        return (
          <li
            style={{ ...styles }}
            onKeyDown={onClickHandler}
            value={index}
            role="button"
            tabIndex={0}
            title={`${label} ${index + 1}`}
            aria-label={`${label} ${index + 1}`}
            onClick={onClickHandler}
          ></li>
        );
      }}
    >
      <div className="flex flex-col f items-center text-[#0D5AD9]">
        <div className="flex">
          <p className="text-sm font-normal flex items-center gap-x-2">
            Total Balance
            <MdRemoveRedEye />
          </p>
        </div>
        <p className="bal font-bold">
          {walletData?.getWallet && walletData.getWallet?.balance} AFYA
        </p>
      </div>

      <div className="flex flex-col f items-center text-[#0D5AD9]">
        <div className="flex">
          <p className="text-sm font-normal flex items-center">
            Earnings from questionnaire
            <MdRemoveRedEye size={20} />
          </p>
          <button className="px-2"></button>
        </div>
        <p className="bal font-bold">
          {walletData?.getWallet && loggedInRole === Role.Patient
            ? walletData?.getWallet?.patient?.task
            : loggedInRole === Role.Chw
            ? walletData?.getWallet?.chw?.task
            : loggedInRole === Role.Practitioner
            ? walletData?.getWallet?.practitioner?.interaction
            : walletData?.getWallet?.balance}{" "}
          AFYA
        </p>
      </div>

      <div className="flex flex-col f items-center text-[#0D5AD9]">
        <div className="flex">
          <p className="text-sm font-normal flex items-center">
            Earning from visit to clinics <MdRemoveRedEye size={20} />
          </p>
          <button className="px-2">{/*  */}</button>
        </div>
        <p className="bal font-bold">
          {walletData?.getWallet && loggedInRole !== Role.Minor
            ? walletData?.getWallet?.patient?.interaction
            : walletData?.getWallet?.balance}{" "}
          AFYA
        </p>
      </div>

      <div className="flex flex-col f items-center text-[#0D5AD9]">
        <div className="flex">
          <p className="text-sm font-normal flex items-center">
            AFYA received from benefactors <MdRemoveRedEye size={24} />
          </p>
          <button className="px-2">{/* <MdRemoveRedEye /> */}</button>
        </div>
        <p className="bal font-bold">
          {walletData?.getWallet && walletData?.getWallet?.received} AFYA
        </p>
      </div>
    </Carousel>
  );
}
